import request from '@/utils/request'

let ProductApi = {

  /*分类管理*/
  catList (data, errorback) {
    return request._post('/shop/product/category/index', data, errorback)
  },
  /*分类添加*/
  catAdd (data, errorback) {
    return request._postBody('/shop/product/category/add', data, errorback)
  },
  /*分类删除*/
  catDel (data, errorback) {
    return request._post('/shop/product/category/delete', data, errorback)
  },
  /*分类修改*/
  catEdit (data, errorback) {
    return request._postBody('/shop/product/category/edit', data, errorback)
  },

  resetES (data, errorback) {
    return request._post('/shop/product/product/resetES', data, errorback)
  },

  /*产品列表*/
  productList (data, errorback) {
    return request._postBody('/shop/product/product/index', data, errorback)
  },
  /*产品选择列表*/
  chooseLists (data, errorback) {
    //return request._postBody('/shop/product/product/index', data, errorback);
    return request._postBody('/shop/data/product/lists', data, errorback)
  },
  squareLists (data, errorback) {
    return request._postBody('/shop/data/product/square/lists/sort', data, errorback)
  },
  chooseelectionSquareLists (data, errorback) {
    //return request._postBody('/shop/product/product/index', data, errorback);
    return request._postBody('/shop/data/product/choose/lists', data, errorback)
  },
  /*规格选择列表*/
  chooseSpec (data, errorback) {
    return request._post('/shop/data/product/spec', data, errorback)
  },
  /*新增产品*/
  addProduct (data, errorback) {
    return request._postBody('/shop/product/product/add', data, errorback)
  },

  /*产品基础数据*/
  getBaseData (data, errorback) {
    return request._get('/shop/product/product/toAdd', data, errorback)
  },
  /*删除产品*/
  delProduct (data, errorback) {
    return request._post('/shop/product/product/delete', data, errorback)
  },
  /*产品基础数据*/
  getEditData (data, errorback) {
    return request._get('/shop/product/product/edit', data, errorback)
  },

  /*供应商产品数据*/
  getSupplierProductData (data, errorback) {
    return request._get('/shop/product/product/supplier/edit', data, errorback)
  },
  /*编辑供应商产品佣金和*销售方式 */
  editSupplierProductData (data, errorback) {
    return request._postBody('/shop/product/product/supplierEdit', data, errorback)
  },

  /*新增产品*/
  editProduct (data, errorback) {
    return request._postBody('/shop/product/product/edit', data, errorback)
  },
  /*新增规格组*/
  addSpec (data, errorback) {
    return request._post('/shop/product/spec/addSpec', data, errorback)
  },
  /*新增规格值*/
  addSpecValue (data, errorback) {
    return request._post('/shop/product/spec/addSpecValue', data, errorback)
  },
  /*商品列表不带分页*/
  getList (data, errorback) {
    return request._post('/shop/data/product/lists', data, errorback)
  },
  /*商品列表不带分页*/
  getActiveProductList (data, errorback) {
    return request._post('/shop/plus.fans.product/lists', data, errorback)
  },
  /*商品应用技术列表*/
  getTechnologyList (data, errorback) {
    return request._postBody('/shop/product/technology/index', data, errorback)
  },
  addProductTechnology (data, errorBack) {
    return request._postBody('/shop/product/technology/add', data, errorBack)
  },
  editProductTechnology (data, errorBack) {
    return request._postBody('/shop/product/technology/edit', data, errorBack)
  },
  getTechnologyDetail (data, errorback) {
    return request._post('/shop/product/technology/detail', data, errorback)
  },
  delTechnology (data, errorback) {
    return request._post('/shop/product/technology/delete', data, errorback)
  },

  /*商品评论列表*/
  getCommentList (data, errorback) {
    return request._postBody('/shop/product/comment/index', data, errorback)
  },
  /*获取评论详情*/
  getComment (data, errorback) {
    return request._post('/shop/product/comment/detail', data, errorback)
  },
  /*获取评论详情*/
  editComment (data, errorback) {
    return request._postBody('/shop/product/comment/edit', data, errorback)
  },
  /*删除评论*/
  delComment (data, errorback) {
    return request._post('/shop/product/comment/delete', data, errorback)
  },
  /*得到分类图片*/
  cateImage (data, errorback) {
    return request._post('/shop/product.category/image', data, errorback)
  },
  /*修改状态*/
  changeStatus (data, errorback) {
    return request._post('/shop/product/product/state', data, errorback)
  },
  /*修改状态*/
  changeAudit (data, errorback) {
    return request._post('/shop/product/product/audit', data, errorback)
  },
  /*供应商新增产品*/
  addSupplierProduct (data, errorback) {
    return request._postBody('/shop/supplier/supplier/addProduct', data, errorback)
  },
  /*供应商商品列表*/
  supplierProductList (data, errorback) {
    return request._postBody('/shop/data/product/supplier/lists', data, errorback)
  },
  /*删除供应商产品*/
  supplierDeleteProduct (data, errorBack) {
    return request._postBody('/shop/supplier/supplier/deleteProduct', data, errorBack)
  },
  addProductComment (data, errorBack) {
    return request._postBody('/shop/product/comment/add', data, errorBack)
  },
  supplierPresaleList (data, errorback) {
    return request._postBody('/shop/product/product/presale/index', data, errorback)
  },
  setProductCommission (data, errorBack) {
    return request._postBody('/shop/product/product/setCommission', data, errorBack)
  },
  setProductCommission2 (data, errorBack) {
    return request._postBody('/shop/product/product/setCommission2', data, errorBack)
  },
  batchAddCategory (data, errorBack) {
    return request._postBody('/shop/product/product/batchsetcategory', data, errorBack)
  },
  batchAddAudit (data, errorBack) {
    return request._postBody('/shop/product/product/batchaudit', data, errorBack)
  },
  /*商品使用方法列表*/
  getUsageList (data, errorback) {
    return request._postBody('/shop/product/usage/index', data, errorback)
  },
  addProductUsage (data, errorBack) {
    return request._postBody('/shop/product/usage/add', data, errorBack)
  },
  editProductUsage (data, errorBack) {
    return request._postBody('/shop/product/usage/edit', data, errorBack)
  },
  getUsageDetail (data, errorback) {
    return request._post('/shop/product/usage/detail', data, errorback)
  },
  delUsage (data, errorback) {
    return request._post('/shop/product/usage/delete', data, errorback)
  },
  /*解决方案列表*/
  getSolutionList (data, errorback) {
    return request._postBody('/shop/product/solution/index', data, errorback)
  },

  addProductSolution (data, errorBack) {
    return request._postBody('/shop/product/solution/add', data, errorBack)
  },
  editProductSolution (data, errorBack) {
    return request._postBody('/shop/product/solution/edit', data, errorBack)
  },
  delSolution (data, errorback) {
    return request._post('/shop/product/solution/delete', data, errorback)
  },

  /*商品分组列表*/
  getProductGroupList (data, errorback) {
    return request._postBody('/shop/product/group/index', data, errorback)
  },
  addProductGroup (data, errorBack) {
    return request._postBody('/shop/product/group/add', data, errorBack)
  },
  editProductGroup (data, errorBack) {
    return request._postBody('/shop/product/group/edit', data, errorBack)
  },
  delProductGroup (data, errorback) {
    return request._post('/shop/product/group/delete', data, errorback)
  },

  /*分组商品列表*/
  getNoGroupList (data, errorback) {
    return request._postBody('/shop/product/group/product/noGroup/index', data, errorback)
  },
  getGroupProductList (data, errorback) {
    return request._postBody('/shop/product/group/product/index', data, errorback)
  },
  addGroupProduct (data, errorback) {
    return request._postBody('/shop/product/group/product/add', data, errorback)
  },
  DeleteGroupProduct (data, errorback) {
    return request._post('/shop/product/group/product/delete', data, errorback)
  },
  getHotWord (data, errorback) {
    return request._postBody('/shop/product/hotword/index', data, errorback)
  }
}

export default ProductApi



// WEBPACK FOOTER //
// ./src/api/product.js